import { MdZoomIn, MdZoomOut } from 'react-icons/md';
import { CustomRendererStyled } from '@/components/Features/Common/styles/FileMsgPDFStyled';
import { FaDownload } from 'react-icons/fa';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { VscLoading } from 'react-icons/vsc';
const PDFControls = ({ setPdfScale, isBusy, pdfScale, onDownload, canDownload }) => {
    const handleZoomIn = () => {
        if (pdfScale <= 3) {
            setPdfScale(Number((pdfScale + 0.1).toFixed(1)));
        }
    };

    const handleZoomOut = () => {
        if (pdfScale >= 0.5) {
            setPdfScale(Number((pdfScale - 0.1).toFixed(1)));
        }
    };

    return (
        <CustomRendererStyled>
            <div className="d-flex align-items-center">
                <div className="d-flex align-items-center mr-3">
                    <BootstrapToolTip text="Zoom Out">
                        <button
                            type="button"
                            className="p-2"
                            disabled={pdfScale <= 0.5 || isBusy}
                            onClick={handleZoomOut}
                        >
                            <MdZoomOut size={20} />
                        </button>
                    </BootstrapToolTip>

                    <span className="mx-2" style={{ minWidth: '60px', textAlign: 'center' }}>
                        {Math.round(pdfScale * 100)}%
                    </span>

                    <BootstrapToolTip text="Zoom In">
                        <button type="button" className="p-2" disabled={pdfScale >= 3 || isBusy} onClick={handleZoomIn}>
                            <MdZoomIn size={20} />
                        </button>
                    </BootstrapToolTip>
                </div>
                {canDownload && (
                    <BootstrapToolTip text="Download PDF">
                        <button type="button" className="p-2" disabled={isBusy} onClick={onDownload}>
                            {isBusy ? <VscLoading className="spin" /> : <FaDownload size={18} />}
                        </button>
                    </BootstrapToolTip>
                )}
            </div>
        </CustomRendererStyled>
    );
};

export default PDFControls;
